module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_01 (1).dd6b07fb.png";